import { render, staticRenderFns } from "./AddTeam.vue?vue&type=template&id=ca0c3fa6&scoped=true&"
import script from "./AddTeam.vue?vue&type=script&lang=js&"
export * from "./AddTeam.vue?vue&type=script&lang=js&"
import style0 from "./AddTeam.vue?vue&type=style&index=0&id=ca0c3fa6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ca0c3fa6",
  null
  
)

component.options.__file = "AddTeam.vue"
export default component.exports